import { useTranslator } from "@eo-locale/react";

import { Box } from "@/storybook-components";

import { roles } from "../lib/roles";
import { useAppSelector } from "@/redux/store/hooks";

const ProfileLinks = () => {
  const { SiteAdmin, PlatformAdmin, HubAdmin, ProjectAdmin } = roles;
  const { translate } = useTranslator();
  const { site } = useAppSelector((state) => state.site);
  const { features } = useAppSelector((state) => state.features);
  const { homePageRevision } = useAppSelector(
    (state) => state.homePageRevision
  );
  const backgroundColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarBackgroundColor;
  const { profile } = useAppSelector((state) => state.user.registeredUser);
  const { roleName } = profile;

  const generateProfileEditLink = () => {
    switch (roleName) {
      case "platform_admin":
        return "/platform/profile/edit";

      case "site_admin":
      case "hub_admin":
      case "project_admin":
        return `/platform/profile/edit`;

      case "participant":
        return "/profile";

      default:
        return "/profile";
    }
  };
  const handleClick = async () => {
    const isSiteBlocked = site.blocked;
    const isSiteOnboardingEnabled =
      features?.enableSiteOnboarding && features.enableSiteOnboarding.enabled;

    const response = await fetch("/admin/api/auth/logout", {
      method: "DELETE"
    });

    if (response.ok) {
      const isAnAdmin =
        [SiteAdmin, PlatformAdmin, HubAdmin, ProjectAdmin].indexOf(roleName) !==
        -1;
      const showAdminLoginPage =
        isSiteBlocked && isAnAdmin && isSiteOnboardingEnabled;

      // Full navigation keeps logout redirects working under App and Pages.
      window.location.assign(showAdminLoginPage ? "/admin/login" : "/login");
    }
  };

  const isAdminUIDashboardEnabled = () =>
    features?.["switchToAdminUi"]?.enabled &&
    features?.["reportingDashboardV2"]?.enabled
      ? "/adm"
      : "/admin/dashboard";

  return (
    <div className="auth-links">
      <ul className="auth-links__list mobile-auth-links">
        <Box
          as="li"
          className="auth-links__list__list-item"
          backgroundColor={backgroundColor}
        >
          <li className="auth-links__list__list-item">
            <a
              href={generateProfileEditLink()}
              className="auth-links__list__list-item__link"
              data-testid="participant-header-mobile-my-account-link"
            >
              {translate("participantHeader.myAccount")}
            </a>
          </li>
          {[
            "platform_admin",
            "site_admin",
            "hub_admin",
            "project_admin"
          ].indexOf(roleName) > -1 && (
            <li className="auth-links__list__list-item">
              <a
                href="/admin/projects"
                aria-expanded="false"
                className="auth-links__list__list-item__link"
                data-testid="participant-header-mobile-projects-link"
              >
                {translate("participantHeader.projects")}
              </a>
            </li>
          )}
          {[
            "platform_admin",
            "site_admin",
            "hub_admin",
            "project_admin"
          ].indexOf(roleName) > -1 && (
            <li className="auth-links__list__list-item">
              <a
                href={isAdminUIDashboardEnabled()}
                aria-expanded="false"
                className="auth-links__list__list-item__link"
                data-testid="participant-header-mobile-dashboard-link"
              >
                {translate("participantHeader.dashboard")}
              </a>
            </li>
          )}
          {["platform_admin", "site_admin"].indexOf(roleName) > -1 && (
            <li className="auth-links__list__list-item">
              <a
                href="/admin/sites/editors/home-page"
                aria-expanded="false"
                className="auth-links__list__list-item__link"
                data-testid="participant-header-mobile-appearance-link"
              >
                {translate("participantHeader.appearance")}
              </a>
            </li>
          )}
          {["project_admin", "hub_admin"].indexOf(roleName) > -1 && (
            <li className="auth-links__list__list-item">
              <a
                href="/admin/subscriptions"
                aria-expanded="false"
                className="metismenu auth-links__list__list-item__link"
                data-testid="participant-header-mobile-manage-subscription-link"
              >
                {translate("participantHeader.manageSubscription")}
              </a>
            </li>
          )}
          <li className="auth-links__list__list-item">
            <a
              href="#!"
              onClick={handleClick}
              className="auth-links__list__list-item__link"
              data-testid="participant-header-mobile-logout-link"
            >
              {translate("participantHeader.logout")}
            </a>
          </li>
        </Box>
      </ul>
    </div>
  );
};

export default ProfileLinks;
